"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SkeletonLoaderModule = _interopRequireDefault(require("./SkeletonLoader.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SkeletonLoader = function SkeletonLoader(_ref) {
  var _ref$height = _ref.height,
    height = _ref$height === void 0 ? '56px' : _ref$height;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _SkeletonLoaderModule["default"].skeletonLoader,
    style: {
      height: height
    },
    "aria-hidden": "true",
    role: "presentation"
  });
};
var _default = exports["default"] = SkeletonLoader;